import { NAVBAR_USER_SUPPORT_FORM_SHOW, NAVBAR_USER_SUPPORT_FORM_SUBMIT } from 'client/redux/navbar/constants';
import * as actionCreators from 'client/redux/navbar/actionCreators';
import { accountSupportForm } from 'client/redux/account/actionCreators';

export const navbarUserSupportFormShow = isOpen => dispatch => {
  return dispatch(actionCreators.navbarUserSupportFormShow(NAVBAR_USER_SUPPORT_FORM_SHOW, isOpen));
};

export const navbarUserSupportFormSubmit = props => dispatch => dispatch(accountSupportForm(NAVBAR_USER_SUPPORT_FORM_SUBMIT, props));
